<template>
  <div>
    <SGPMainTabComponent >
      <SGPTabComponent title="Listar">
        <ListagemMenusComponent />
      </SGPTabComponent>
      <!-- <SGPTabComponent title="Criar Rota" v-if="permissoesPerfis.adm_aplicacao">
        <ListagemRotaComponent />
      </SGPTabComponent>
      <SGPTabComponent title="Associação Rota" v-if="permissoesPerfis.adm_aplicacao">
        <ListagemPerfilRotaComponent />
      </SGPTabComponent>
      <SGPTabComponent title="Caminho URL" v-if="permissoesPerfis.adm_aplicacao">
        <ListagemVueComponenteMenuComponent />
      </SGPTabComponent> -->
      <SGPTabComponent title="Associar Perfis">
        <ListagemPerfilMenuComponent />
      </SGPTabComponent>
      <SGPTabComponent title="Menu vs Perfil">
        <ListagemMenuXPerfilComponent />
      </SGPTabComponent>
    </SGPMainTabComponent >        
    

  </div>
</template>

<script>

import ListagemMenusComponent from '../components/abas/ListagemMenusComponent.vue';
// import ListagemRotaComponent from '@/modules/app/rotas/components/ListagemRotaComponent.vue';
// import ListagemVueComponenteMenuComponent from '@/modules/app/vue-componentes-menus/components/ListagemVueComponenteMenuComponent.vue';
import ListagemPerfilMenuComponent from '@/modules/app/perfis-menus/components/ListagemPerfilMenuComponent.vue';
// import ListagemPerfilRotaComponent from '@/modules/app/perfis-rotas/components/ListagemPerfilRotaComponent.vue';
import ListagemMenuXPerfilComponent from '../components/abas/ListagemMenuXPerfilComponent.vue';


export default {
  components: { 
    ListagemMenusComponent,
    // ListagemRotaComponent,
    // ListagemVueComponenteMenuComponent,
    ListagemPerfilMenuComponent,
    // ListagemPerfilRotaComponent,
    ListagemMenuXPerfilComponent
  },
  name: 'MenuPage',
 
  // data () {
  //   let sessao = JSON.parse(localStorage.getItem("provedores-usuario"));

  //   return {
  //     permissoesPerfis: sessao.permissoesPerfis
  //   }
  // }

  data() {
    const sessao = JSON.parse(localStorage.getItem("provedores-usuario"));
    const roles = sessao.roles?.map(r => r.name) ?? [];

    const permissoesPerfis = {
      adm_aplicacao: roles.includes('administrador'),
    };

    return {
      permissoesPerfis
    };
  }
}
</script>
